import { MARKETING_URL } from '../../lib/env';
import { COMPANY_LEGAL } from '../../lib/company';

export function AuthLegalFooter() {
  return (
    <div className="space-y-3 p-6 text-center">
      <p className="mx-auto max-w-sm text-[11px] leading-relaxed text-gray-400 dark:text-gray-500">
        {COMPANY_LEGAL.name}
        <br />
        {COMPANY_LEGAL.address}
        <br />
        {COMPANY_LEGAL.gpsCode} · Reg. No. {COMPANY_LEGAL.registrationNumber}
      </p>
      <p className="mx-auto max-w-sm text-xs text-gray-400 dark:text-gray-500">
        By continuing, you agree to Coordal&apos;s{' '}
        <a
          href={`${MARKETING_URL}/legal/terms`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-gray-600 dark:hover:text-gray-300"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href={`${MARKETING_URL}/legal/privacy`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-gray-600 dark:hover:text-gray-300"
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
}
